<template>
    <div :class="[prefixCls]">
        <div
            :id="uploadBtnId"
            :class="classes"
            @drop="dragOver = false"
            @dragover.prevent="dragOver = true"
            @dragleave.prevent="dragOver = false"
            style="width: 32px;margin-bottom: 10px"
        >
            <slot></slot>
        </div>
        <div v-if="(fileInfo.url !='' && cut_done) || imageUrl != ''" style="border:1px solid #dcdee2" :style="cutWH">
            <LiveRoomImage :src="src" :defaultPic="require('@/assets/noimage.jpg')" alt="" class="auto" />
        </div>
        <slot name="tip"></slot>
        <upload-status
            v-if="file.id && cut_done"
            :file="file"
            :showCloseBtn="showCloseBtn"
            :cut_done="cut_done"
            @on-file-remove="handleRemove"
            @on-file-preview="handlePreview"
        ></upload-status>
        <Modal v-model="cut_dialog" :mask-closable="false" @on-visible-change="onVisibleChange" width="580">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('Components.upload.cutDialog.title') }}</span>
            </p>
            <ul class="tab-ul">
                <li
                    :class="activeClass == 'across' ? 'active':''"
                    @click="activeClass = 'across';changeFix(16, 9)"
                >{{ $t('Components.upload.uploadLiveRoomPic.type.across') }}</li>
                <li
                    :class="activeClass == 'vertical' ? 'active':''"
                    @click="activeClass = 'vertical';changeFix(9, 16)"
                >{{ $t('Components.upload.uploadLiveRoomPic.type.vertical') }}</li>
            </ul>
            <div style="text-align:center">
                <div class="vue-cropper-box">
                    <div class="vue-cropper-content">
                        <vueCropper ref="cropper"
                            style="width: 496px;height: 279px"
                            :img="option.img"
                            :outputSize="option.outputSize"
                            :outputType="option.outputType"
                            :info="option.info"
                            :canScale="option.canScale"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :fixed="option.fixed"
                            :fixedNumber="option.fixedNumber"
                            :full="option.full"
                            :infoTrue="option.full"
                            :maxImgSize="option.maxImgSize"
                            :centerBox="option.centerBox"
                            :enlarge="option.enlarge"
                            @imgLoad="imgLoad"
                        ></vueCropper>
                    </div>
                </div>
                <p style="font-size: 14px;margin-top: 20px;color: red;text-align: center">{{ $t('Components.upload.uploadLiveRoomPic.prompt') }}</p>
            </div>
            <div slot="footer">
                <Button size="large" long :loading="cut_dialog_loading" @click="onCubeImg">{{ $t('Components.upload.cutDialog.onCubeImg') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>

import { mapState, mapMutations } from "vuex";
import { VueCropper } from "vue-cropper"
import UploadStatus from "./upload-status.vue";
import LiveRoomImage from "@/components/LiveRoomImage";
import config from "@/config";

import streamUpload from "./stream-v1-upload";

import Filetype from "file-type";

const prefixCls = "ivu-upload";

window.Filetype = Filetype;

export default {
    name: "Upload",
    components: {
        UploadStatus,
        VueCropper,
        LiveRoomImage
    },
    props: {
        action: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: "file"
        },
        maxSize: {
            type: Number,
            default: 5242880
        },
        id: {
            type: String
        },
        imageUrl: {
            type: String
        },
        fixedNumber: {
            type: Array
        },
        enlarge: {
        	type: Number,
        	default: 1
        },
        maxImgSize: {// 图片最大宽高
        	type: Number,
        	default: 1280
        },
        full: {
        	type: Boolean,
        	default: false
        },
        type: {
            type: Number,
            default: 0
        },
        resize: {
            type: Number
        },
        showCloseBtn: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            uploadBtnId: 'uploadBtn'+String(Math.random()).replace('.', ''),
            prefixCls: prefixCls,
            dragOver: false,
            cut_dialog: false,
            cut_dialog_loading: false,
            file: {},
            tempIndex: 1,
            option: {
                img: '',                         //裁剪图片的地址
                info: true,                      //裁剪框的大小信息
                outputSize: 1,                   // 裁剪生成图片的质量
                outputType: 'jpeg',              //裁剪生成图片的格式
                canScale: true,                 // 图片是否允许滚轮缩放
                autoCrop: true,                  // 是否默认生成截图框
                autoCropWidth: null,                //默认生成截图框宽度
                autoCropHeight: null,                //默认生成截图框高度
                fixed: true,                    //是否开启截图框宽高固定比例
                fixedNumber: this.fixedNumber,              //截图框的宽高比例
                enlarge: this.enlarge, 			//截图大小与截图框的比例，越大截出的图片越大
                full: this.full,				//按原图尺寸1比1输出（不是指宽高比）
                centerBox: false,
                maxImgSize: this.maxImgSize
            },
            fileInfo: {
                url: ''
            },
            activeClass: 'across',
            cut_done: false,
            imgSrc: ''
        };
    },
    watch: {
        action() {
            this.ins.config.tokenURL = this.action + "/tk";
            this.ins.config.uploadURL =
                this.action + "/newFileStreamUpload?type=" + this.type;
            if (this.resize) {
                this.ins.config.uploadURL += "&resize=" + this.resize;
            }
        },
        file(val) {
            this.$store.commit("uploader/setUploading", val);
        },
        fixedNumber(){
            this.option.fixedNumber = this.fixedNumber
        },
        'option.fixedNumber'(){
            if (this.cut_dialog){
                console.log("fixedNumber has changed",this.option.fixedNumber)
                if (this.option.fixedNumber[0] == 16 && this.option.fixedNumber[1] == 9){
                    this.option.autoCropWidth = this.$refs.cropper.getImgAxis().x2 - this.$refs.cropper.getImgAxis().x1;
                    this.option.autoCropHeight = (this.$refs.cropper.getImgAxis().x2 - this.$refs.cropper.getImgAxis().x1) * 9 / 16;
                }
                else if (this.option.fixedNumber[0] == 9 && this.option.fixedNumber[1] == 16){
                    this.option.autoCropWidth = (this.$refs.cropper.getImgAxis().y2 - this.$refs.cropper.getImgAxis().y1) * 9 / 16;
                    this.option.autoCropHeight = this.$refs.cropper.getImgAxis().y2 - this.$refs.cropper.getImgAxis().y1;
                }
                console.log("W",this.option.autoCropWidth);
                console.log("H",this.option.autoCropHeight);
                console.log(this.$refs.cropper.getImgAxis());
            }
        },
        "maxSize"(val) {
            if(val) {
                // if(!this.fixedNumber) {
                    // this.ins.config.maxSize = val;
                // }
                this.ins.config.maxSize = val;
            }
        }
    },
    computed: {
        ...mapState({
            userId: state => state.user.id
        }),
        classes() {
            return [
                `${prefixCls}`,
                {
                    [`${prefixCls}-select`]: true,
                    // [`${prefixCls}-drag`]: true,
                    // [`${prefixCls}-dragOver`]: this.dragOver
                }
            ];
        },
        src(){
            if(this.fileInfo.url != "" && this.cut_done){
                return this.fileInfo.url
            }else {
                return this.imageUrl
            }
        },
        cutWH(){
            let width = 200;
            let height = 200;

            if(this.fixedNumber && this.fixedNumber.length == 2) {
                if(this.fixedNumber[0] > this.fixedNumber[1]) {
                    width = 200;
                    height = this.fixedNumber[1] / this.fixedNumber[0] * width;
                } else {
                    height = 200;
                    width = this.fixedNumber[0] / this.fixedNumber[1] * height;
                }
            }
            return { width: width+'px', height: height+'px' };
        }
    },
    methods: {
        upload(zoom){

            if(zoom && zoom != 1) {
                this.zoomTo(zoom, ()=> {
                    this.checkInsWaitingStatus(()=> this.upload());
                });
            } else {
                try{
                    this.file.uploadProgress = true;
                    this.ins.upload();
                }catch (e){
                    this.$Notice.error({ title: this.$t('Components.upload.message.uploadError'), desc: e });
                }
            }
        },
        pause(){
            try{
                this.ins.stop();
            }catch (e){
                this.$Notice.error({ title: this.$t('Components.upload.message.pauseError'), desc: e });
            }
        },
        cancel(){
            try{
                this.ins.cancel();
            }catch (e){
                this.$Notice.error({ title: this.$t('Components.upload.message.cancelError'), desc: e });
            }
        },
        isUploading() {
            let ret;
            this.file.status === "uploading";
            return ret;
        },
        getFile(file) {
            let target;
            target = file;
            return target;
        },
        handleRemove(file) {
            // 手工取消任务，先从fileList移除，再取消，方便在onCancel中判断是否是用户行为
            try {
                this.ins.cancelOne(file.id);
                this.file = {};
                this.fileInfo = {
                    url: ''
                };
            } catch (error) { } // 如果已经调用过cancelOne，在调用会出错
        },
        handlePreview(file) {
            if (file.status === "finished") {
                // this.onPreview(file);
                this.$emit("on-preview", file);
            }
        },
        // 裁剪图片
        onCubeImg() {
            // debugger
            this.$refs.cropper.getCropBlob(blob => {
                this.replaceByBlob(blob);
                //关闭裁剪框
                this.cut_dialog = false;
                //更改裁剪状态
                this.cut_done = true;
                this.fileInfo.url = this.option.img;
            }, "image/jpeg", 0.95);
        },
        // 调用repalceBlob后图片并不会马上进入ins的上传列表中，需要使用checkInsWaitingStatus检查ins.waiting.length
        replaceByBlob(blob, isZoom) {
            this.ins.cancel();
            //预览图
            this.fileInfo.url && URL.revokeObjectURL(this.fileInfo.url);
            this.fileInfo.url = URL.createObjectURL(blob);

            //先将显示图片地址清空，防止重复显示
            this.option.img = "";

            let file = new window.File([blob], this.file.name, {type: blob.type});
            file.isCut = true;
            file.isZoom = isZoom;

            // 添加blob到stream插件中
            this.ins.fileProvider.updateFileList({
                target: { files: [file] }
            });
        },
        zoomTo(zoom, callback) {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = image.width * zoom;
                canvas.height = image.height * zoom;

                const ctx = canvas.getContext("2d");
                const newHeight = ctx.drawImage(
                    image,
                    0,
                    0,
                    image.width,
                    image.height,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );
                canvas.toBlob(blob=> {
                   this.replaceByBlob(blob, true);
                   callback && callback();
                }, "image/png", .95);
            };
            image.src = this.fileInfo.url;
        },
        // 检查图像是否已添加到ins的上传列表中
        checkInsWaitingStatus(callback) {
            if(!this.ins.waiting.length) {
                setTimeout(()=> this.checkInsWaitingStatus(callback), 200);
                return;
            }
            callback();
        },
        //截图框图片加载完成方法
        imgLoad(result){
            if (result){
                console.log("img onload");
                if (this.option.fixedNumber[0] == 16 && this.option.fixedNumber[1] == 9) {
                    this.option.autoCropWidth = this.$refs.cropper.getImgAxis().x2 - this.$refs.cropper.getImgAxis().x1;
                    this.option.autoCropHeight = (this.$refs.cropper.getImgAxis().x2 - this.$refs.cropper.getImgAxis().x1) * 9 / 16;
                }
                else if (this.option.fixedNumber[0] == 9 && this.option.fixedNumber[1] == 16) {
                    this.option.autoCropWidth = (this.$refs.cropper.getImgAxis().y2 - this.$refs.cropper.getImgAxis().y1) * 9 / 16;
                    this.option.autoCropHeight = this.$refs.cropper.getImgAxis().y2 - this.$refs.cropper.getImgAxis().y1;
                }
                console.log("Width", this.option.autoCropWidth);
                console.log("Height", this.option.autoCropHeight);
                console.log(this.$refs.cropper.getImgAxis());
            }
        },
        //点击裁剪框关闭按钮
        onVisibleChange(visible){
            if (!visible && !this.cut_done){
                this.file = {};
                this.fileInfo = { url: '' };
                this.$store.commit('uploader/setUploadPath', "");
                this.ins.cancel();
            }
        },
        //更改播放器背景图裁剪类型
        changeFix(width, height){
            this.option.fixedNumber.splice(0, 2, width, height);
            this.$refs.cropper.goAutoCrop();
        },
    },
    beforeDestroy() {
        this.ins.destroy();
    },
    mounted() {
        let THIS = this;
        let _uploadingFile = null; //特殊处理
        
        // let uploadUrl = config.cmsServer+"upload/newFileStreamUpload.action?type="+this.type;
        // if(this.resize) {
        //     uploadUrl += '&resize='+this.resize;
        // }
        let uploadURL = this.action + "/newFileStreamUpload?type=" + this.type;
        if (this.resize) {
            uploadURL += "&resize=" + this.resize;
        }

        this.ins = streamUpload({
            // tokenURL: config.cmsServer+"upload/tk.action",
            tokenUR: this.action + "/tk",
            uploadURL,
            browseFileId: this.uploadBtnId,
            dragAndDropArea: this.uploadBtnId,
            // maxSize: this.fixedNumber ? undefined : this.maxSize, // 启用裁剪时忽略上传限制
            maxSize: this.maxSize, // 启用裁剪时忽略上传限制
            simLimit: 10000, /** 允许同时选择文件上传的个数（包含已经上传过的） */
            // autoRemoveCompleted: true,/** 是否自动移除已经上传完毕的文件，非自定义UI有效(customered:false)，默认是false */
            multipleFiles: false,
            extFilters: [".mpg", ".jpg", ".JPG", ".jpeg", ".png"],
            postVarsPerFile: { /** 上传文件时传入的参数，默认: {} */
                // roomID : this.id,
                // userID: this.userId,
                // appID: 102
            },
            // autoUploading: true,
            getExtType: Filetype,
            onExtNameMismatch: function (info) {

            },
            onAddTask: function(file, files) {
                // debugger
                THIS.ins.cancel();
                THIS.file = {
                    name: file.name,
                    id: file.id,
                    status: "uploading",
                    showProgress: false,
                    percentage: 0
                };

                //把图片添加到裁剪框
                THIS.option.img && URL.revokeObjectURL(THIS.option.img);
                THIS.option.img = URL.createObjectURL(files.file);
                // THIS.fileInfo.url = THIS.option.img;

                //如果是上传的图片，执行以下操作
                if(!files.file.isCut){
                    THIS.cut_done = false;
                    // 传了fixedNumber才做裁剪，by wuml 2019-10-30 20:50:32
                    if (!files.file.isCut && THIS.fixedNumber) {
                        //若为选择文件时打开裁剪框
                        THIS.cut_dialog = true;
                        //内部属性，清除input的选择状态使其能选同一个文件
                        THIS.ins.fileProvider.fileInputField.value = "";
                    } else if(!files.file.isZoom) {
                        THIS.$emit("on-select", file, THIS.fileInfo.url);
                    }
                }
            },
            onRepeatedFile: function(file) {
                console.log("文件： " + file.name
                    + " 大小：" + file.size + "已存在于上传队列中");
                // return flase;
            },
            onUploadProgress: function(file) {
                THIS.file.percentage = file.percent || 0;
            },
            onStop: function () {
                THIS.$Notice.info({ title: THIS.$t('Components.upload.message.uploadPause') });
            },
            onCancel : function(file) {
                // THIS.$Notice.error({ title: file.name + " 已取消上传" });
                THIS.file.showProgress = false;
                THIS.file.status = "error";
            },
            onComplete: function(file) {
                if (THIS.file) {
                    file.msg = JSON.parse(file.msg);
                    THIS.file.status = "finished";
                    THIS.file.response = file;

                    THIS.$emit("on-success", file, THIS.file);
                    THIS.$store.dispatch("uploader/onUploaded", {
                        res: file,
                        file: THIS.file,
                        uploadServer: THIS.action
                    });
                    THIS.file.showProgress = false;
                }
                //保存操作
                THIS.$emit('save');
            },

        });

        // 处理服务器返回错误
        // 因为 onUploadError 没返回具体文件，这里通过插件内部事件和方法获取
        this.ins.fileProvider.on("uploaderror", event => {
            const fileId = event.target.get("id");
            const _file = THIS.getFile({ id: fileId });

            _file.status = "fail";

            // 不自动取消出错的文件的话，上传会暂停
            this.ins.cancelOne(fileId);
        });

    },
    destroyed() {
        if(this.showCloseBtn){
            this.file = {};
            this.fileInfo = { url: '' };
            this.$store.commit('uploader/setUploadPath', "");
        }
        URL.revokeObjectURL(this.fileInfo.url);
        URL.revokeObjectURL(this.option.img);
    }
};
</script>

<style lang="less" scoped>
    .vue-cropper-box{
        width: 496px;
        height: 279px;
        margin: 0 auto;
    }
    .auto {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .tab-ul{
        white-space:nowrap;
        list-style: none;
        margin: 0;
        padding: 0;
        line-height: 19px;

        li{
            list-style: none;
            display: inline-block;
            margin-right: 15px;
            padding-bottom: 3px;
            float: left;
            font-size: 14px;
            cursor: pointer;
            text-align: center;
        }
        .active {
            color: rgb(255, 102, 0);
            font-weight: bolder;
            border-bottom: rgb(255, 102, 0) 3px solid;
        }
    }
    .tab-ul:after{
        content:'';
        visibility:hidden;
        display:block;
        width:0;
        height:0;
        clear:both;
        margin-bottom: 15px;
    }
</style>

